// @flow
import type {SagaIterator} from 'redux-saga';

import {call, put} from 'redux-saga/effects';
import {globalDataLayerPageSaga} from 'actions/globalDataLayer/globalDataLayer';

/**
 * Send analytics for HP
 * @param {{event: string, page: string}} data - Current data
 * @param {string} affId - Current affId
 */
export function* sendAnalyticsForHP(data: {event: string, page: string}): SagaIterator {
    const saveAppPageAction = yield call(globalDataLayerPageSaga, data.page);
    yield put(saveAppPageAction);
}
